/* ═══════════════════════════════════════════════════════════════
   Timesheets rebuild — one shared hour-value clipboard for every
   grid cell (overhead + project rows). Module-scoped, mirrors the
   design-token clipboard pattern in forma-studio/useFormaEditorPanels.tsx — a
   spreadsheet-style "copy this cell's value" clipboard, distinct
   from the browser's native text clipboard (these are single-number
   cells, not free text spans).
   ═══════════════════════════════════════════════════════════════ */

let clipboardValue: number | null = null;

export function copyHourValue(v: number): void {
  clipboardValue = v;
}

export function readHourClipboard(): number | null {
  return clipboardValue;
}

export function hasHourClipboard(): boolean {
  return clipboardValue !== null;
}
